module.exports = __webpack_public_path__ + "static/img/C4D0028.0083bba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0028.jpg
// module id = chgI
// module chunks = 0